import React from "react";
import {EventClassPage} from "./EventClassPage";

export default ()=>{
    return (<EventClassPage/>)
}